var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountancyHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Accountancy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.406,
    height: 74.03,
    viewBox: "0 0 72.406 74.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M330.742,253H307.885a.885.885,0,0,0-.885.885v5.161a.885.885,0,0,0,.885.885h22.857a.885.885,0,0,0,.885-.885v-5.161A.885.885,0,0,0,330.742,253Zm-1.032,5.161H308.77V254.77h20.94Z",
    transform: "translate(-263.203 -216.428)",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M313.1,441.468a3.54,3.54,0,1,0-3.54-3.54A3.54,3.54,0,0,0,313.1,441.468Zm0-5.31a1.771,1.771,0,1,1-1.77,1.771,1.771,1.771,0,0,1,1.77-1.771Z",
    transform: "translate(-265.383 -371.067)",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M370.047,441.468a3.54,3.54,0,1,0-3.54-3.54A3.54,3.54,0,0,0,370.047,441.468Zm0-5.31a1.771,1.771,0,1,1-1.771,1.771,1.771,1.771,0,0,1,1.771-1.771Z",
    transform: "translate(-313.934 -371.067)",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M427,441.468a3.54,3.54,0,1,0-3.54-3.54A3.54,3.54,0,0,0,427,441.468Zm0-5.31a1.771,1.771,0,1,1-1.771,1.771A1.771,1.771,0,0,1,427,436.158Z",
    transform: "translate(-362.487 -371.067)",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M313.1,388.493a3.54,3.54,0,1,0-3.54-3.54A3.54,3.54,0,0,0,313.1,388.493Zm0-5.31a1.771,1.771,0,1,1-1.77,1.77A1.771,1.771,0,0,1,313.1,383.183Z",
    transform: "translate(-265.383 -325.904)",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M370.047,388.493a3.54,3.54,0,1,0-3.54-3.54A3.54,3.54,0,0,0,370.047,388.493Zm0-5.31a1.771,1.771,0,1,1-1.771,1.77A1.771,1.771,0,0,1,370.047,383.183Z",
    transform: "translate(-313.934 -325.904)",
    fill: "#000000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M427,388.493a3.54,3.54,0,1,0-3.54-3.54A3.54,3.54,0,0,0,427,388.493Zm0-5.31a1.771,1.771,0,1,1-1.77,1.77A1.771,1.771,0,0,1,427,383.183Z",
    transform: "translate(-362.487 -325.904)",
    fill: "#000000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M313.1,335.521a3.54,3.54,0,1,0-3.54-3.54A3.54,3.54,0,0,0,313.1,335.521Zm0-5.311a1.771,1.771,0,1,1-1.77,1.771A1.771,1.771,0,0,1,313.1,330.211Z",
    transform: "translate(-265.383 -280.743)",
    fill: "#000000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M370.047,335.521a3.54,3.54,0,1,0-3.54-3.54A3.54,3.54,0,0,0,370.047,335.521Zm0-5.311a1.771,1.771,0,1,1-1.771,1.771A1.771,1.771,0,0,1,370.047,330.211Z",
    transform: "translate(-313.934 -280.744)",
    fill: "#000000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M427,335.521a3.54,3.54,0,1,0-3.54-3.54A3.54,3.54,0,0,0,427,335.521Zm0-5.311a1.771,1.771,0,1,1-1.771,1.771A1.771,1.771,0,0,1,427,330.211Z",
    transform: "translate(-362.487 -280.744)",
    fill: "#000000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M163.652,309h-9.217a.885.885,0,0,0,0,1.77h9.217a.885.885,0,0,0,0-1.77Z",
    transform: "translate(-132.382 -264.169)",
    fill: "#000000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M125.87,310.77h.9a.885.885,0,0,0,0-1.77h-.9a.885.885,0,0,0,0,1.77Z",
    transform: "translate(-108.029 -264.169)",
    fill: "#000000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M180.206,360h-4.813a.885.885,0,1,0,0,1.77h4.813a.885.885,0,1,0,0-1.77Z",
    transform: "translate(-150.249 -307.649)",
    fill: "#000000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M129.716,360H125.87a.885.885,0,1,0,0,1.77h3.846a.885.885,0,1,0,0-1.77Z",
    transform: "translate(-108.029 -307.649)",
    fill: "#000000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M101.885,46.806a.885.885,0,0,0-.885.885v.356a.885.885,0,1,0,1.77,0v-.356A.885.885,0,0,0,101.885,46.806Z",
    transform: "translate(-87.581 -40.641)",
    fill: "#000000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M101.885,72.649a.885.885,0,0,0-.885.885V85.254a.885.885,0,1,0,1.77,0V73.534A.885.885,0,0,0,101.885,72.649Z",
    transform: "translate(-87.581 -62.673)",
    fill: "#000000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M155.12,64.854A13.056,13.056,0,1,0,168.176,77.91,13.056,13.056,0,0,0,155.12,64.854Zm11.266,12.409h-9.368l6.678-6.678A11.234,11.234,0,0,1,166.386,77.263ZM155.12,66.624a11.234,11.234,0,0,1,7.325,2.71l-7.321,7.321-5.761-8.446A11.216,11.216,0,0,1,155.12,66.624Zm0,22.573a11.281,11.281,0,0,1-7.2-19.969l6.423,9.418a.885.885,0,0,0,.731.386H166.35A11.3,11.3,0,0,1,155.12,89.2Z",
    transform: "translate(-122.589 -56.027)",
    fill: "#000000"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M77.924,37.886H66.037V18.824a2.46,2.46,0,0,0-.7-1.732L54.277,5.748A2.48,2.48,0,0,0,52.509,5H21.563a2.435,2.435,0,0,0-2.42,2.479V9.866H16.789a2.472,2.472,0,0,0-1.77.695,2.407,2.407,0,0,0-.743,1.719V13.7H12.492a2.451,2.451,0,0,0-1.76.7A2.4,2.4,0,0,0,10,16.12V74.9a2.518,2.518,0,0,0,2.494,2.509H50.552A4.473,4.473,0,0,0,54,79.029H77.924a4.482,4.482,0,0,0,4.482-4.482V42.367a4.482,4.482,0,0,0-4.481-4.482ZM53.8,7.788l9.3,9.6H58.277a4.481,4.481,0,0,1-3.168-1.348,4.533,4.533,0,0,1-1.311-3.2Zm-37.751,4.49a.65.65,0,0,1,.226-.468.719.719,0,0,1,.519-.175h2.352V66.417a2.4,2.4,0,0,0,2.422,2.437H49.521v2.8H16.791a.786.786,0,0,1-.745-.759ZM12.494,75.638a.739.739,0,0,1-.509-.223.748.748,0,0,1-.216-.517V16.119a.647.647,0,0,1,.215-.471.7.7,0,0,1,.509-.178h1.783V70.9a2.555,2.555,0,0,0,2.514,2.528h32.73v1.122a4.488,4.488,0,0,0,.134,1.091Zm37.026-33.27v7.869a.884.884,0,0,0-.743-.406H45.466a.885.885,0,0,0,0,1.77h3.311a.884.884,0,0,0,.743-.406v6.157H43.359a.885.885,0,0,0,0,1.77h6.162v7.963H21.565a.623.623,0,0,1-.473-.187.634.634,0,0,1-.18-.481V7.477a.664.664,0,0,1,.652-.708H52.028v6.066a6.309,6.309,0,0,0,6.248,6.321h5.992V37.886H54a4.482,4.482,0,0,0-4.482,4.482Zm31.263,32.18a2.73,2.73,0,0,1-2.73,2.712H54.074a2.777,2.777,0,0,1-2.783-2.712V51.6H80.783Zm0-24.717H51.29V42.37a2.78,2.78,0,0,1,2.783-2.715h23.98a2.733,2.733,0,0,1,2.73,2.715Z",
    transform: "translate(-10 -5)",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountancyHub);
export default __webpack_public_path__ + "static/media/AccountancyHub.260062de2d0990501b4bd4f36de31a8d.svg";
export { ForwardRef as ReactComponent };